import * as types from "../constants/actionConstants";
import * as portalShared from "../portal/shared/metadataConstantsAndUtilities";
import {editorOriginMatches, EDITOR_TYPES} from "../utilities/editorInstanceOwnership";

const initialState = {
    instanceId: null,
    template: {
        templateKey: "",
        name: "",
        nameQualifier: null,
        description: "",
        script: "",
        metadata: {},
        questionKeys: [],
        showGroupKeys: [],
        answerOptionTemplates: [],
        visible: true
    },
    questionKeys: [],
    options: {
        hasScript: false,
        hasDescription: false,
        validate: [],
        isValidating: false
    }
};

export default function groupEditorReducer(state = initialState, action) {
    let addQuestion;
    let newState;
    let newAnswerOptions;
    let newTemplate;
    let target;
    let removed;
    let clonedGroupTemplate;

    switch (action.type) {
        case types.GROUP_EDITOR_INITIALIZE:
            return {
                ...state,
                ...action.payload
            };

        case types.GROUP_EDITOR_UPDATE:
            return {
                ...state,
                template: {
                    ...state.template,
                    ...action.payload.template
                },
                options: {
                    ...state.options,
                    ...action.payload.options
                }
            };

        case types.GROUP_EDITOR_CLEAR:
            return {
                ...initialState
            };

        case types.QUESTION_TEMPLATE_CREATE_SUCCESS:
            if (!editorOriginMatches(action.origin, EDITOR_TYPES.GROUP, state)) {
                return state;
            }
            addQuestion = [
                ...state.questionKeys,
                action.questionTemplate.templateKey
            ];
            return {
                ...state,
                questionKeys: addQuestion
            };

        case types.GROUP_EDITOR_ADD_QUESTION:// eslint-disable-line no-case-declarations

            clonedGroupTemplate = portalShared.cloneObj(state.template);
            clonedGroupTemplate.questionKeys = clonedGroupTemplate.questionKeys.includes(action.questionKey) ? clonedGroupTemplate.questionKeys : [...clonedGroupTemplate.questionKeys, action.questionKey];

            addQuestion = [
                ...state.questionKeys,
                action.questionKey
            ];

            return {
                ...state,
                template: clonedGroupTemplate,
                questionKeys: addQuestion
            };

        case types.GROUP_EDITOR_REMOVE_QUESTION:// eslint-disable-line no-case-declarations

            newState = portalShared.cloneObj(state);

            let removedQuestionKey = state.questionKeys[action.index];

            newState.template.questionKeys = newState.template.questionKeys.filter(key => key !== removedQuestionKey);

            let removeQuestion = state.questionKeys.filter((element, index) => {
                return index !== action.index;
            });

            newState.questionKeys = removeQuestion;

            return newState;

        case types.GROUP_EDITOR_REORDER:// eslint-disable-line no-case-declarations
            let questionKeys = [...state.questionKeys];
            target = (action.isUp)? -1 : 1;
            target = target + action.currentIndex;

            if (target < 0) { target=0;}
            else if (target > questionKeys.length -1) {target = questionKeys.length -1;}

            removed = questionKeys.splice(action.currentIndex, 1);
            questionKeys.splice(target, 0, removed[0]);
            return {
                ...state,
                questionKeys
            };

        case types.GROUP_EDITOR_NAME_AND_QUALIFIER_EXISTS:
            return {
                ...state,
                options: {
                    ...state.options,
                    validate: action.list,
                    isValidating: false
                }
            };
        case types.GROUP_EDITOR_NAME_AND_QUALIFIER_VALIDATING:
            return {
                ...state,
                options: {
                    ...state.options,
                    isValidating: true
                }
            };

        case types.GROUP_EDITOR_UPDATE_TYPE:
            newState = {...state};

            newTemplate = {
                ...state.template,
                questionGroupType: action.questionGroupType,
                answerOptionTemplates: []
            };

            // Clear out the selected questions to ensure that only Likert questions go in a Likert group and vice versa
            newState = {
                ...newState,
                template: newTemplate,
                questionKeys: []
            };
            return newState;

        case types.ANSWER_EDITOR_ADD_GROUP_ANSWER:
            newState = {...state};

            newAnswerOptions = [
                ...state.template.answerOptionTemplates,
                action.answer
            ];

            newTemplate = {
                ...state.template,
                answerOptionTemplates: newAnswerOptions
            };

            newState = {
                ...newState,
                template: newTemplate
            };

            return newState;

        case types.ANSWER_EDITOR_UPDATE_GROUP_ANSWER:

            //debugger; // SSSSS Show Group Testing
            newState = portalShared.cloneObj(state);

            newAnswerOptions = [
                ...newState.template.answerOptionTemplates
            ];

            newAnswerOptions[action.index] = action.answer;

            newTemplate = {
                ...newState.template,
                answerOptionTemplates: newAnswerOptions
            };

            // NOTE: Wwe only allow 1 show group per answer!
            if (action.answer.importGroupKeys.length && !newTemplate.showGroupKeys.includes(action.answer.importGroupKeys[0])) {
                newTemplate.showGroupKeys.push(action.answer.importGroupKeys[0]);
            }

            newState = {
                ...newState,
                template: newTemplate
            };
            return newState;

            // newState = [...state];
            // newState[action.depth] = {...newState[action.depth]};
            // let answerOptions = [
            //     ...state[action.depth].answerOptionTemplates
            // ];
            // answerOptions[action.index] = {...action.answer};
            // newState[action.depth].answerOptionTemplates = answerOptions;
            // return newState;


        case types.ANSWER_EDITOR_REMOVE_GROUP_ANSWER:// eslint-disable-line no-case-declarations
            newState = {...state};

            newAnswerOptions = [
                ...state.template.answerOptionTemplates
            ];

            newAnswerOptions = state.template.answerOptionTemplates.filter((element, index) => {
                return index !== action.index;
            });

            newTemplate = {
                ...state.template,
                answerOptionTemplates: newAnswerOptions
            };

            newState = {
                ...newState,
                template: newTemplate
            };

            return newState;

        case types.ANSWER_EDITOR_REORDER_GROUP_ANSWER:// eslint-disable-line no-case-declarations
            //debugger; // SSSSS Show Group Testing
            newState = {...state};

            newAnswerOptions = [
                ...state.template.answerOptionTemplates
            ];

            target = (action.isUp)? -1 : 1;
            target = target + action.currentIndex;

            if (target < 0) { target=0;}
            else if (target > newAnswerOptions.length -1) {target = newAnswerOptions.length -1;}

            removed = newAnswerOptions.splice(action.currentIndex, 1);
            newAnswerOptions.splice(target, 0, removed[0]);

            newTemplate = {
                ...state.template,
                answerOptionTemplates: newAnswerOptions
            };

            newState = {
                ...newState,
                template: newTemplate
            };

            return newState;

        case types.GROUP_EDITOR_ADD_SHOW_GROUP_KEYS:

            newState = portalShared.cloneObj(state);

            for (let i = 0; i < action.showGroupKeys.length; i++) {
                if (!newState.template.showGroupKeys.includes(action.showGroupKeys[i])) {
                    newState.template.showGroupKeys.push(action.showGroupKeys[i]);
                }
            }

            return newState;

        case types.GROUP_EDITOR_SET_SHOW_GROUP_KEYS:
            //debugger; // SSSSS Show Group Testing
            newState = portalShared.cloneObj(state);

            // When a show group is removed from an answer the question is not changed
            if (action.removedQuestionKey !== "") {
                newState.template.questionKeys = newState.template.questionKeys.filter(key => key !== action.removedQuestionKey);
            }

            newState.template.showGroupKeys = action.showGroupKeys;

            return newState;

        default:
            return state;
    }
}
